"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Error = void 0;
var _react = require("react");
var _Error = require("./Error.styles");
var _hooks = require("../../../../../hooks");
var _AudiencePicker = require("../../../AudiencePicker.labels");
var _Modal = require("../../../../../Layout/Modal");
var _Button = require("../../../../../UI/Button");
var _CetComponentsProvider = require("../../../../../providers/CetComponentsProvider");
var _errorImg_rtl = _interopRequireDefault(require("../../../resources/errorImg_rtl.png"));
var _errorImg_ltr = _interopRequireDefault(require("../../../resources/errorImg_ltr.png"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Error = props => {
  const {
    onGoBack,
    title,
    subTitle
  } = props;
  const {
    direction = 'rtl'
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const styles = (0, _Error.useStyles)();
  const getLabel = (0, _hooks.useLabels)({
    labels: _AudiencePicker.labels
  });
  const errorImg = {
    rtl: _errorImg_rtl.default,
    ltr: _errorImg_ltr.default
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Header, {
      messageIcon: "BrokenHeart",
      messageType: "alert",
      message: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Content, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-AudiencePicker__error'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: subTitle
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-AudiencePicker__error__image-wrapper'],
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: errorImg[direction],
            alt: "Error",
            className: styles['cc-AudiencePicker__error__image']
          })
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer, {
      justifyContent: "center",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          view: "outlined",
          onClick: onGoBack,
          children: getLabel('back')
        })
      })
    })]
  });
};
exports.Error = Error;